export default __webpack_public_path__ + "static/media/Heather.ae9935ef.jpg";